import store from '@/store'
import { path, gt, length, intersection, flatten, values, pick, keys, includes } from 'ramda'
export function checkPermission (groups) {
    switch (arguments.length) {
        case 0:
            return false
        case 1: {
            let groupsInProfile = flatten([path(['state', 'permission', 'groups'], store), path(['state', 'permission', 'dep', 'id'], store)])
            groupsInProfile = groupsInProfile.map(item => item ? item.toLowerCase(): '')
            groups = groups.map(item => item ? item.toLowerCase() : '')
            return gt(length(intersection(groupsInProfile ? groupsInProfile : [], groups ? groups : [])), 0)
        }
        default:
            return false
        }
}

export function getPermission(metaDataPerm) {
    let userGroup = flatten([path(['state', 'permission', 'groups'], store), path(['state', 'permission', 'dep', 'id'], store)])
    userGroup = userGroup.map(item => item ? item.toLowerCase() : '')
    return flatten(values(pick(userGroup ? userGroup : [], metaDataPerm ? metaDataPerm : {})).map(item => keys(item)))
}

export function canInCollection(action, collection) {
    let perm = keys(path(['state','permission', 'specificPermission', collection], store))
    return includes(action, perm ? perm : [])
}